/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SamplingDataListViewModel } from '../../models/sampling-data-list-view-model';

export interface GetSamplingData$Params {
  productionOrderId: number;
}

export function getSamplingData(http: HttpClient, rootUrl: string, params: GetSamplingData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SamplingDataListViewModel>>> {
  const rb = new RequestBuilder(rootUrl, getSamplingData.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SamplingDataListViewModel>>;
    })
  );
}

getSamplingData.PATH = '/api/v1/QaCheck/{productionOrderId}/GetSamplingData';
